import { render, staticRenderFns } from "./WaardenExplanation.vue?vue&type=template&id=54c79638&scoped=true&"
import script from "./WaardenExplanation.vue?vue&type=script&lang=js&"
export * from "./WaardenExplanation.vue?vue&type=script&lang=js&"
import style0 from "./WaardenExplanation.vue?vue&type=style&index=0&id=54c79638&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c79638",
  null
  
)

export default component.exports